var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVRespetc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#724C99;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_38_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st0",
    d: "M114.1,175.9c-2.4,0-4.3-1.9-4.3-4.3v-18c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3v18 C118.3,174,116.4,175.9,114.1,175.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st0",
    d: "M128.2,175.9c-2.4,0-4.3-1.9-4.3-4.3v-32.8c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3v32.8 C132.5,174,130.6,175.9,128.2,175.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    className: "st0",
    d: "M142.4,175.7c-2.4,0-4.3-1.9-4.3-4.3v-32.6c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3v32.6 C146.7,173.8,144.8,175.7,142.4,175.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st0",
    d: "M156.6,200.5c-2.4,0-4.3-1.9-4.3-4.3v-27.5c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3v27.5 C160.8,198.6,158.9,200.5,156.6,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    className: "st0",
    d: "M156.6,249.9H106c-2.4,0-4.3-1.9-4.3-4.3v-10.1c0-6.7-1-13.3-3-19.7l-0.8-2.5 c-1.5-4.9-2.3-10.1-2.3-15.2v-44c0-5.4,3.6-10.2,8.7-11.4c1.9-0.4,3.7-0.4,5.5,0v-3.5c0-5.4,3.6-10.2,8.6-11.4 c2.2-0.5,4.3-0.4,6.3,0.3c1.3-3.5,4.2-6.2,7.8-7c3.4-0.8,7,0,9.7,2.1c1.6,1.3,2.9,3,3.6,4.9c2-0.7,4.1-0.8,6.3-0.3 c5,1.2,8.7,6,8.7,11.4v17.1c1.7-0.7,3.6-1,5.6-0.9c6.9,0.4,12.7,6.7,12.7,13.9v27.4c0,6.6-2.5,12.9-7,17.7l-10.2,11 c-0.7,0.7-1,1.6-1,2.6v17.6C160.8,248,158.9,249.9,156.6,249.9z M110.2,241.4h42.1V228c0-3.1,1.2-6.1,3.3-8.4l10.2-11 c3-3.2,4.7-7.5,4.7-11.9v-27.4c0-2.6-2.2-5.2-4.6-5.4c-1.3,0-2.6,0.4-3.6,1.3c-1,0.9-1.5,2.2-1.5,3.5c0,2.4-1.9,4.3-4.3,4.3 c-2.4,0-4.3-1.9-4.3-4.3v-29.6c0-1.5-0.9-2.8-2.1-3.1c-1.2-0.3-2.1,0.2-2.5,0.5c-0.7,0.5-1.1,1.4-1.1,2.2c0,2.4-1.9,4.3-4.3,4.3 c-2.4,0-4.3-1.9-4.3-4.3v-6.7c0-0.9-0.4-1.7-1.1-2.2c-0.4-0.3-1.3-0.8-2.5-0.5c-1.2,0.3-2.1,1.6-2.1,3.1v6.4c0,2.4-1.9,4.3-4.3,4.3 c-2.4,0-4.3-1.9-4.3-4.3c0-0.9-0.4-1.7-1.1-2.2c-0.4-0.3-1.3-0.8-2.5-0.5c-1.2,0.3-2.1,1.6-2.1,3.1v14.5c0,2.4-1.9,4.3-4.3,4.3 c-2.4,0-4.3-1.9-4.3-4.3c0-0.9-0.4-1.7-1.1-2.2c-0.4-0.3-1.3-0.8-2.5-0.5c-1.2,0.3-2.1,1.6-2.1,3.1v44c0,4.3,0.6,8.6,1.9,12.7 l0.8,2.5c2.2,7.2,3.4,14.7,3.4,22.2V241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st0",
    d: "M139.1,124.1c-0.7,0-1.5-0.2-2.1-0.6l-12.6-7.3c-2-1.2-2.7-3.8-1.6-5.8c1.2-2,3.8-2.7,5.8-1.6 l12.6,7.3c2,1.2,2.7,3.8,1.6,5.8C142,123.3,140.6,124.1,139.1,124.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st0",
    d: "M128.2,134.1c-0.7,0-1.5-0.2-2.1-0.6l-8.8-5.1c-2-1.2-2.7-3.8-1.6-5.8c1.2-2,3.8-2.7,5.8-1.6 l8.8,5.1c2,1.2,2.7,3.8,1.6,5.8C131.1,133.4,129.7,134.1,128.2,134.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st0",
    d: "M101.8,151.6c-0.7,0-1.5-0.2-2.1-0.6l-17.8-10.3c-2-1.2-2.7-3.8-1.6-5.8c1.2-2,3.8-2.7,5.8-1.6 l17.8,10.3c2,1.2,2.7,3.8,1.6,5.8C104.7,150.8,103.2,151.6,101.8,151.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st0",
    d: "M99.8,171.3c-0.5,0-0.9-0.1-1.4-0.2c-0.9-0.3-1.7-0.7-2.4-1.1l-23.7-13.7 c-5.7-3.3-9.9-8.6-11.8-14.9l-4.4-14.4c-0.3-0.9-0.9-1.7-1.7-2.2L39.1,116c-1-0.6-1.7-1.5-2-2.6c-0.3-1.1-0.1-2.3,0.4-3.2 l25.3-43.8c0.6-1,1.5-1.7,2.6-2c1.1-0.3,2.3-0.1,3.2,0.4l8.8,5.1c5.8,3.3,12,5.8,18.6,7.3l2.5,0.6c5,1.1,9.9,3,14.4,5.6l26.6,15.4 c2,1.2,2.7,3.8,1.6,5.8c-1.2,2-3.8,2.7-5.8,1.6l-26.6-15.4c-3.7-2.2-7.8-3.7-12-4.7l-2.5-0.6c-7.4-1.7-14.4-4.4-20.9-8.2l-5.1-2.9 L47,110.8l11.6,6.7c2.7,1.6,4.7,4.1,5.6,7.1l4.4,14.4c1.3,4.2,4.1,7.8,7.9,10l23.7,13.7c0.3,0.2,0.6,0.3,0.9,0.4 c2.2,0.8,3.4,3.2,2.6,5.4C103.3,170.2,101.6,171.3,99.8,171.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st0",
    d: "M157.6,165.1c-1.5,0-2.9-0.8-3.7-2.1c-1.2-2-0.5-4.6,1.6-5.8l13.9-8c2-1.2,4.6-0.5,5.8,1.6 c1.2,2,0.5,4.6-1.6,5.8l-13.9,8C159.1,164.9,158.3,165.1,157.6,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st0",
    d: "M157.6,148.8c-1.5,0-2.9-0.8-3.7-2.1c-1.2-2-0.5-4.6,1.6-5.8l6.8-3.9c2-1.2,4.6-0.5,5.8,1.6 c1.2,2,0.5,4.6-1.6,5.8l-6.8,3.9C159.1,148.6,158.3,148.8,157.6,148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st0",
    d: "M152.9,135.1c-1.5,0-2.9-0.8-3.7-2.1c-1.2-2-0.5-4.6,1.6-5.8l4.2-2.4c2-1.2,4.6-0.5,5.8,1.6 c1.2,2,0.5,4.6-1.6,5.8l-4.2,2.4C154.4,134.9,153.7,135.1,152.9,135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st0",
    d: "M147.7,121.7c-1.5,0-2.9-0.8-3.7-2.1c-1.2-2-0.5-4.6,1.6-5.8l23.8-13.8c2-1.2,4.6-0.5,5.8,1.6 c1.2,2,0.5,4.6-1.6,5.8l-23.8,13.8C149.2,121.5,148.5,121.7,147.7,121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st0",
    d: "M175.2,171.3c-1.5,0-2.9-0.8-3.7-2.1c-1.2-2-0.5-4.6,1.6-5.8l26.2-15.1c3.7-2.2,7.1-4.9,10.1-8 l1.8-1.9c5.1-5.5,11-10.3,17.6-14l5.1-2.9l-21.1-36.5l-11.6,6.7c-2.7,1.6-5.9,2-8.9,1.3l-14.7-3.4c-4.3-1-8.8-0.3-12.6,1.9 l-23.7,13.7c-2.3,1.3-3.4,4.5-2.3,6.7c0.6,1.2,1.7,2.1,2.9,2.5c1.3,0.4,2.6,0.2,3.8-0.4c2-1.2,4.6-0.5,5.8,1.6 c1.2,2,0.5,4.6-1.6,5.8c0,0-11.8,6.8-11.8,6.8c-2,1.2-4.6,0.5-5.8-1.6c-1.2-2-0.5-4.6,1.6-5.8l1-0.6c-1.5-1.2-2.7-2.7-3.5-4.4 c-3.1-6.1-0.5-14.3,5.7-17.9L160.7,84c5.7-3.3,12.4-4.3,18.8-2.8l14.7,3.4c0.9,0.2,1.9,0.1,2.8-0.4l15.3-8.8c1-0.6,2.1-0.7,3.2-0.4 c1.1,0.3,2,1,2.6,2l25.3,43.8c1.2,2,0.5,4.6-1.6,5.8l-8.8,5.1c-5.8,3.3-11,7.5-15.6,12.4l-1.8,1.9c-3.5,3.8-7.6,7-12,9.6 l-26.2,15.1C176.7,171.1,176,171.3,175.2,171.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    className: "st0",
    d: "M241.3,130.1c-0.4,0-0.7,0-1.1-0.1c-1.1-0.3-2-1-2.6-2l-28.7-49.7c-1.2-2-0.5-4.6,1.6-5.8 l15.9-9.2c1.8-1,4-0.6,5.3,0.9c13.2,15.2,22.5,33.5,27.1,53c0.4,1.8-0.4,3.7-2,4.7l-13.3,7.7C242.8,129.9,242,130.1,241.3,130.1z M218.4,77.7l24.4,42.3l6.8-3.9c-4.2-15.9-11.8-30.8-22.2-43.6L218.4,77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    className: "st0",
    d: "M39.5,119.6c-0.7,0-1.5-0.2-2.1-0.6l-15.9-9.2c-1.8-1-2.6-3.2-1.9-5.1 C26.1,85.8,37.4,68.6,52,54.8c1.4-1.3,3.4-1.5,5-0.6l13.3,7.7c1,0.6,1.7,1.5,2,2.6c0.3,1.1,0.1,2.3-0.4,3.2l-28.7,49.7 C42.4,118.8,41,119.6,39.5,119.6z M28.8,104.2l9.1,5.3l24.4-42.3l-6.8-3.9C43.9,74.8,34.7,88.9,28.8,104.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st0",
    d: "M137.4,270.4c-12.2,0-24.3-1.8-36-5.3c-1.8-0.5-3-2.2-3-4.1v-15.4c0-2.4,1.9-4.3,4.3-4.3H160 c2.4,0,4.3,1.9,4.3,4.3v18.3c0,2-1.5,3.8-3.5,4.2C153,269.6,145.1,270.4,137.4,270.4z M106.8,257.8c15.8,4.3,32.4,5.2,48.9,2.6 v-10.5h-48.9V257.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st0",
    d: "M137.4,270.4c-66.5,0-121.2-52-124.5-118.4c-0.1-2.3,1.7-4.3,4-4.5c2.5-0.1,4.3,1.7,4.5,4 c3.1,61.8,54.1,110.3,116,110.3c25.6,0,49.9-8.2,70.2-23.6c1.9-1.4,4.5-1.1,6,0.8c1.4,1.9,1.1,4.5-0.8,6 C190.9,261.6,164.8,270.4,137.4,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st0",
    d: "M18.7,129.2c-0.2,0-0.5,0-0.7-0.1c-2.3-0.4-3.9-2.6-3.5-4.9c5.7-32.7,24.6-62.3,52-81.2 c1.9-1.3,4.6-0.9,5.9,1.1c1.3,1.9,0.9,4.6-1.1,5.9c-25.5,17.7-43.2,45.2-48.5,75.7C22.5,127.8,20.7,129.2,18.7,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M113.6,31.8c-2,0-3.8-1.4-4.2-3.4c-0.5-2.3,1-4.5,3.3-5c2.3-0.5,4.6-0.9,7-1.2 c2.3-0.3,4.5,1.3,4.8,3.6c0.3,2.3-1.3,4.5-3.6,4.8c-2.2,0.3-4.3,0.7-6.5,1.1C114.2,31.8,113.9,31.8,113.6,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st0",
    d: "M89.6,39.3c-1.6,0-3.2-1-3.9-2.6c-0.9-2.2,0.1-4.7,2.2-5.6C90.6,30,93.3,29,96,28 c2.2-0.8,4.6,0.4,5.4,2.6c0.8,2.2-0.4,4.6-2.6,5.4c-2.5,0.9-5.1,1.9-7.5,3C90.7,39.2,90.2,39.3,89.6,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M68.9,50.8c-1.4,0-2.7-0.6-3.5-1.8c-1.3-1.9-0.9-4.6,1.1-5.9c1.9-1.3,3.9-2.6,5.9-3.8 c2-1.2,4.6-0.6,5.8,1.4c1.2,2,0.6,4.6-1.4,5.8c-1.9,1.1-3.7,2.3-5.5,3.6C70.6,50.6,69.8,50.8,68.9,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M257.8,149.9c-2.4,0-4.3-1.9-4.3-4.3c0-64.1-52.1-116.2-116.2-116.2c-5.5,0-11,0.4-16.4,1.1 c-2.3,0.3-4.5-1.3-4.8-3.6c-0.3-2.3,1.3-4.5,3.6-4.8c5.8-0.8,11.7-1.2,17.6-1.2C206.1,21,262,76.9,262,145.7 C262,148,260.1,149.9,257.8,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M210.1,245.9c-1.3,0-2.6-0.6-3.4-1.7c-1.4-1.9-1.1-4.5,0.8-6c1.7-1.3,3.5-2.7,5.1-4.1 c1.8-1.5,4.5-1.3,6,0.5c1.5,1.8,1.3,4.5-0.5,6c-1.8,1.5-3.6,3-5.5,4.4C211.9,245.6,211,245.9,210.1,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    className: "st0",
    d: "M232.2,224.1c-0.9,0-1.8-0.3-2.6-0.9c-1.9-1.5-2.2-4.1-0.7-6c2.4-3.1,4.7-6.3,6.8-9.6 c1.3-2,3.9-2.6,5.9-1.3c2,1.3,2.6,3.9,1.3,5.9c-2.2,3.5-4.7,7-7.3,10.3C234.8,223.5,233.5,224.1,232.2,224.1z M250.1,192.4 c-0.5,0-1-0.1-1.5-0.3c-2.2-0.8-3.3-3.3-2.5-5.5c1.4-3.6,2.6-7.4,3.6-11.2c0.6-2.3,2.9-3.6,5.2-3c2.3,0.6,3.6,2.9,3,5.2 c-1.1,4.1-2.4,8.1-3.8,12C253.4,191.3,251.8,192.4,250.1,192.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st0",
    d: "M257.6,156.7c-0.1,0-0.2,0-0.2,0c-2.3-0.1-4.1-2.1-4-4.5c0.1-2.2,0.2-4.4,0.2-6.6 c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3c0,2.4-0.1,4.7-0.2,7C261.7,155,259.8,156.7,257.6,156.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVRespetc);
export default __webpack_public_path__ + "static/media/V-respetc.123c7a59dd17551904d9e0170aa37084.svg";
export { ForwardRef as ReactComponent };